import { PageFooter, Corner } from "./chrome";

const STRIP_IMGS = [
  "https://images.unsplash.com/photo-1635424709870-cdc6e64f0e20?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1583345237708-add35a664d77?crop=entropy&cs=srgb&fm=jpg&q=85",
];

export default function AboutPage() {
  return (
    <section className="page" data-testid="page-about">
      <div className="grain" />
      <Corner section="I · About" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Company History</div>
          <h2 className="h-title">
            We are a successful <em>solar solutions</em> company.
          </h2>
        </div>

        <p className="lead-quote">
          <em>INPACE POWER</em> is a fast-growing solar service provider with <em>3+ years</em> of focused industry experience — delivering end-to-end rooftop installation, EPC and AMC services for residential, commercial and industrial customers across <em>Karnataka</em>.
        </p>

        <div className="intro-grid">
          <p className="body">
            From our facility in <strong>Bangalore</strong>, a young, hungry team of <strong>38 professionals</strong> brings together solar design, structural engineering, electrical certification and site execution under one roof. Every installation is engineered, installed, commissioned and maintained by our in-house crews — never sub-contracted.
          </p>
          <p className="body">
            Our work has been recognised by homeowners, business owners and industrial promoters across <strong>Karnataka</strong> for measurable savings, transparent costing and zero-hassle BESCOM approvals. We are the partner customers come back to — and the partner they recommend.
          </p>
        </div>

        <div className="stat-row">
          <div>
            <div className="stat-num">224<span className="plus">+</span></div>
            <div className="stat-label">Residential Installations</div>
          </div>
          <div>
            <div className="stat-num">10</div>
            <div className="stat-label">Commercial Projects</div>
          </div>
          <div>
            <div className="stat-num">08</div>
            <div className="stat-label">Industrial Plants · 200 kW+</div>
          </div>
          <div>
            <div className="stat-num">38</div>
            <div className="stat-label">Team Members</div>
          </div>
        </div>

        <div className="image-strip">
          {STRIP_IMGS.map((src) => (
            <div key={src} style={{ backgroundImage: `url(${src})` }} />
          ))}
        </div>
      </div>
      <PageFooter num="04" />
    </section>
  );
}
